import { ROUTE_WEARABLES } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { RouteObject } from 'react-router-dom';
import Page from './wearables.page';

export const routeWearables: RouteObject = {
  path: ROUTE_WEARABLES,
  Component: Page,
  loader: setTitleFromLoader('Wearables'),
};